import * as _ from 'underscore';
import * as React from 'react';
import { IUserNotification } from '../models/IUserNotification';
import { IUserNotificationContentProvider, NotificationAction } from './INotificationProvider';
import { UserNotificationActions } from '../redux/UserNotificationActions';


export class NotificationDefaultProvider implements IUserNotificationContentProvider {
  public constructor(private userNotificationActions: UserNotificationActions) { }
  public getNotificationTitle(notification: IUserNotification): string {
    return '';
  }

  public getNotificationContent(notification: IUserNotification): string {
    return '';
  }

  public getNotificationActions(notification: IUserNotification): Array<NotificationAction> {
    return [
      {
        title: notification.read ? 'Mark as unread' : 'Mark as read',
        testId: 'mark-as-unread-' + notification.id,
        onClick: () => { this.userNotificationActions.updateUserNotificationsStatus([notification.id], !notification.read); }
      },
      {
        title: 'Remove notification',
        testId: 'remove-notification-' + notification.id,
        onClick: () => { this.userNotificationActions.deleteUnreadUserNotifications([notification.id]); }
      }];
  }
}
